<template>
	<div>
		<div class="category-wrapper">
			<div class="category-nav">
				<ul class="category-nav-items">
					<!--<li class="category-nav-item category-nav-item-active">文学</li>-->
					<li class="category-nav-item" v-for="(item,value) in data" @click="switchCategory(value)" :class="{'category-nav-item-active':value==activeIndex}">{{item.course_type}}</li>
				</ul>
			</div>
			<div class="category-list">
				<ul class="category-list-items">
					<li class="category-list-item" v-for="item in sublist" @click="to('/lesson-list/'+'1/'+item.id)">{{item.course_type}}</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				data: [],
				activeIndex: 0,
				sublist: []
			}
		},
		methods: {
			to(name) {
				this.$router.push(name);
			},
			switchCategory(num) {
				this.activeIndex = num;
				this.sublist = this.data[num].children;
				console.log(this.sublist)
			},
			//点击二级分类
			switchSubCategory(subType) {
				this.$api.get("", {
					api: '/v1/course/index',
					type: 1,
					type_id: subType,
          status: 1,
				}, res => {
					console.log(res);
				})
			}
		},
		created() {
		  console.log(document.referrer)
			this.$api.get("", {
				api: "/v1/Filter/index",
				type: 1
			}, res => {
				this.data = res.data;
				//默认选中第一个
				this.sublist = this.data[0].children;
			})
		}
	}
</script>

<style>
	.category-wrapper {
		display: flex;
		overflow: hidden;
		align-items: stretch;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: #fff;
	}

	.category-nav {
		overflow: scroll;
		width: 3.333rem;
		background: #f2f2f2;
	}

	.category-nav-item {
		overflow: hidden;
		height: 1.306rem;
		line-height: 1.306rem;
		color: #333;
		text-align: center;
		font-size: 0.426rem;
	}

	.category-nav-item-active {
		background: #fff;
	}

	.category-list {
		overflow: scroll;
		margin-left: 0.4rem;
		width: 5.84rem;
	}

	.category-list-item {
		height: 1.573rem;
		line-height: 1.573rem;
		color: #666;
		text-align: center;
		font-size: 0.426rem;
		border-bottom: 1px solid #f3f3f3;
	}
</style>



// WEBPACK FOOTER //
// src/components/category/category.vue